import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    container: {
        padding: `${theme.spacing(3)} ${theme.spacing(7.5)} ${theme.spacing(7.5)} ${theme.spacing(7.5)}`,
        flexGrow: 1,
        "@media (min-width: 1300px)": {
            padding: theme.spacing(7.5),
        },
    },
    gridContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        height: "100%",
        rowGap: theme.spacing(2),
    },
    dropdowns: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(4),
    },
    graphs: {
        alignSelf: "stretch",
    },
    tooltip: {
        "&.MuiTooltip-popper .MuiTooltip-tooltip": {
            backgroundColor: theme.palette.secondary.main,
        },
    },
    tooltipTexts: {
        "&.MuiTypography-root": {
            fontSize: "14px",
            textAlign: "left",
            color: theme.palette.text.primary,
            fontWeight: 600,
            fontFamily: "Open Sans",
            paddingBottom: "5px",
        },
    },
    fab_button: {
        position: "absolute",
        bottom: 32,
        right: 36,
    },
}));
